/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Markasunread3Inputs */

const en_notificationcenter_markasunread3 = /** @type {(inputs: Notificationcenter_Markasunread3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as unread`)
};

/**
* | output |
* | --- |
* | "Mark as unread" |
*
* @param {Notificationcenter_Markasunread3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_markasunread3 = /** @type {((inputs?: Notificationcenter_Markasunread3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Markasunread3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_markasunread3(inputs)
});
export { notificationcenter_markasunread3 as "notificationCenter_markAsUnread" }